export const DSTV = {
  id: "dstv",
  name: "DSTV",
  imageFolder: "/dstv",
  tagline: {
    pt: "DSTV — Televisão por satélite para residências, hotéis e empresas em Angola.",
    en: "DSTV — Satellite television for homes, hotels and businesses in Angola.",
    es: "DSTV — Televisión por satélite para residencias, hoteles y empresas en Angola.",
  },
  color: "#0b5cad",
  theme: {
    bgGradient: "from-[#e8f1fa] via-[#d8e8f5] to-[#dfecf6]",
    blob1: "bg-blue-300/30",
    blob2: "bg-sky-200/40",
    overlineText: "text-blue-700",
    pillarPill: "border-blue-400 text-blue-700",
    segmentHover: "hover:border-blue-400",
    tabHover: "hover:border-blue-400 hover:text-blue-700",
    ctaPrimary:
      "bg-blue-600 hover:bg-blue-700 shadow-blue-600/25 hover:shadow-blue-600/40",
    ctaOutline: "border-blue-400 text-blue-700 hover:bg-blue-50",
    productHover: "hover:border-blue-400",
    productQuoteCta: "border-blue-400 text-blue-700 hover:bg-blue-50",
    productBadge: "text-blue-700",
    productPreviewPill: "text-blue-700",
    whyPanel: "border-blue-200 from-blue-50 to-white",
    whyItemBorder: "border-blue-100",
    whyCheck: "text-blue-600",
    modalHeaderBg: "from-blue-50 via-[#d8e8f5] to-sky-50",
    modalBrandBadge: "border-blue-200 text-blue-700",
    modalInputFocus: "focus:border-blue-500 focus:ring-blue-500/20",
    modalSubmit:
      "bg-blue-600 hover:bg-blue-700 shadow-blue-600/25 hover:shadow-blue-600/40",
  },
  pillars: {
    pt: ["Residencial", "Comercial", "Hotelaria", "Antenas & LNBs"],
    en: ["Residential", "Commercial", "Hospitality", "Dishes & LNBs"],
    es: ["Residencial", "Comercial", "Hotelería", "Antenas y LNBs"],
  },
  segments: {
    pt: [
      { name: "Residências", desc: "Descodificadores HD e 4K para lares, com canais desportivos, filmes e séries." },
      { name: "Hotelaria", desc: "Sistemas multi-quarto com gestão central e canais premium para hóspedes." },
      { name: "Restaurantes & Bares", desc: "Canais desportivos e entretenimento para estabelecimentos comerciais." },
      { name: "Escritórios", desc: "Canais de notícias e informação em áreas comuns e salas de espera." },
      { name: "Compounds", desc: "Instalação coletiva em condomínios com splitter e rede coaxial." },
    ],
    en: [
      { name: "Homes", desc: "HD and 4K decoders for homes, with sports, movies and series channels." },
      { name: "Hospitality", desc: "Multi-room systems with central management and premium channels for guests." },
      { name: "Restaurants & Bars", desc: "Sports and entertainment channels for commercial venues." },
      { name: "Offices", desc: "News and information channels in common areas and waiting rooms." },
      { name: "Compounds", desc: "Collective installation in condos with splitter and coaxial network." },
    ],
    es: [
      { name: "Residencias", desc: "Decodificadores HD y 4K para hogares, con canales deportivos, películas y series." },
      { name: "Hotelería", desc: "Sistemas multi-habitación con gestión central y canales premium." },
      { name: "Restaurantes & Bares", desc: "Canales deportivos y entretenimiento para establecimientos comerciales." },
      { name: "Oficinas", desc: "Canales de noticias e información en áreas comunes y salas de espera." },
      { name: "Compounds", desc: "Instalación colectiva en condominios con splitter y red coaxial." },
    ],
  },
  why: {
    pt: {
      title: "Porquê escolher a DSTV?",
      items: [
        "Maior plataforma de TV por satélite em África",
        "Cobertura em todo o território angolano",
        "Canais em português, inglês e dedicados a Angola",
        "Instalação profissional e alinhamento de antena",
        "Pacotes residenciais, comerciais e hoteleiros",
        "Assistência técnica e manutenção em Angola",
      ],
    },
    en: {
      title: "Why choose DSTV?",
      items: [
        "Largest satellite TV platform in Africa",
        "Coverage across all of Angola",
        "Channels in Portuguese, English and Angola-dedicated",
        "Professional installation and dish alignment",
        "Residential, commercial and hotel packages",
        "Local technical support and maintenance",
      ],
    },
    es: {
      title: "¿Por qué elegir DSTV?",
      items: [
        "Mayor plataforma de TV satélite en África",
        "Cobertura en todo el territorio angoleño",
        "Canales en portugués, inglés y dedicados a Angola",
        "Instalación profesional y alineación de antena",
        "Paquetes residenciales, comerciales y hoteleros",
        "Soporte técnico y mantenimiento local",
      ],
    },
  },
  groups: [
    {
      id: "residencial",
      icon: "dashboard",
      featured: true,
      title: {
        pt: "Residencial — Descodificadores",
        en: "Residential — Decoders",
        es: "Residencial — Decodificadores",
      },
      description: {
        pt: "Descodificadores DSTV para residências — da entrada HD Zapper ao flagship 4K Explora Ultra com gravação PVR e streaming integrado.",
        en: "DSTV decoders for homes — from entry HD Zapper to flagship 4K Explora Ultra with PVR recording and built-in streaming.",
        es: "Decodificadores DSTV para hogares — del HD Zapper básico al flagship 4K Explora Ultra con grabación PVR y streaming integrado.",
      },
      highlights: {
        pt: [
          "HD e 4K Ultra HD",
          "Gravação PVR (Explora)",
          "Streaming DSTV Stream integrado",
          "EPG e catch-up TV",
          "HDMI 2.0 e USB",
          "Instalação e activação em Angola",
        ],
        en: [
          "HD and 4K Ultra HD",
          "PVR recording (Explora)",
          "Built-in DSTV Stream",
          "EPG and catch-up TV",
          "HDMI 2.0 and USB",
          "Installation and activation in Angola",
        ],
        es: [
          "HD y 4K Ultra HD",
          "Grabación PVR (Explora)",
          "DSTV Stream integrado",
          "EPG y catch-up TV",
          "HDMI 2.0 y USB",
          "Instalación y activación en Angola",
        ],
      },
      products: [
        {
          slug: "dstv-explora-ultra",
          pt: "DSTV Explora Ultra — Descodificador 4K com streaming",
          en: "DSTV Explora Ultra — 4K decoder with streaming",
          es: "DSTV Explora Ultra — Decodificador 4K con streaming",
        },
        {
          slug: "dstv-explora-3",
          pt: "DSTV Explora 3 — Descodificador HD com PVR 1TB",
          en: "DSTV Explora 3 — HD decoder with 1TB PVR",
          es: "DSTV Explora 3 — Decodificador HD con PVR 1TB",
        },
        {
          slug: "dstv-hd-pvr",
          pt: "DSTV HD PVR — Descodificador com gravação de 2 canais",
          en: "DSTV HD PVR — Decoder with 2-channel recording",
          es: "DSTV HD PVR — Decodificador con grabación de 2 canales",
        },
        {
          slug: "dstv-hd-zapper",
          pt: "DSTV HD Zapper — Descodificador HD de entrada",
          en: "DSTV HD Zapper — Entry-level HD decoder",
          es: "DSTV HD Zapper — Decodificador HD básico",
        },
      ],
    },
    {
      id: "comercial",
      icon: "network",
      title: {
        pt: "Comercial & Hotelaria",
        en: "Commercial & Hospitality",
        es: "Comercial & Hotelería",
      },
      description: {
        pt: "Soluções DSTV Business e Hotel — sistemas multi-quarto, headend profissional e canais licenciados para estabelecimentos comerciais.",
        en: "DSTV Business and Hotel solutions — multi-room systems, professional headend and licensed channels for commercial venues.",
        es: "Soluciones DSTV Business y Hotel — sistemas multi-habitación, headend profesional y canales licenciados para establecimientos comerciales.",
      },
      products: [
        {
          slug: "dstv-business",
          pt: "DSTV Business — Licença e equipamento para locais comerciais",
          en: "DSTV Business — Licensing and equipment for commercial venues",
          es: "DSTV Business — Licencia y equipamiento para locales comerciales",
        },
        {
          slug: "dstv-commercial",
          pt: "DSTV Commercial Headend — Sistema central multi-quarto",
          en: "DSTV Commercial Headend — Multi-room central system",
          es: "DSTV Commercial Headend — Sistema central multi-habitación",
        },
        {
          slug: "dstv-hotel-kit",
          pt: "DSTV Hotel Kit — Descodificador por quarto com canais premium",
          en: "DSTV Hotel Kit — Per-room decoder with premium channels",
          es: "DSTV Hotel Kit — Decodificador por habitación con canales premium",
        },
      ],
    },
    {
      id: "antenas",
      icon: "antenna",
      title: {
        pt: "Antenas & LNBs",
        en: "Dishes & LNBs",
        es: "Antenas & LNBs",
      },
      description: {
        pt: "Antenas parabólicas DSTV e LNBs Smart para recepção óptima do satélite IS-20 — kits de instalação completos com cabo coaxial e conectores.",
        en: "DSTV dishes and Smart LNBs for optimal reception of the IS-20 satellite — complete installation kits with coaxial cable and connectors.",
        es: "Antenas parabólicas DSTV y LNBs Smart para recepción óptima del satélite IS-20 — kits completos con cable coaxial y conectores.",
      },
      products: [
        {
          slug: "dstv-dish-90cm",
          pt: "Antena DSTV 90 cm — Parabólica offset para Angola",
          en: "DSTV 90 cm Dish — Offset parabolic for Angola",
          es: "Antena DSTV 90 cm — Parabólica offset para Angola",
        },
        {
          slug: "dstv-lnb-smart",
          pt: "LNB Smart DSTV — Para Explora e sistemas multi-quarto",
          en: "DSTV Smart LNB — For Explora and multi-room systems",
          es: "LNB Smart DSTV — Para Explora y sistemas multi-habitación",
        },
      ],
    },
  ],
};
